import script from "./HeaderProject.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderProject.vue?vue&type=script&setup=true&lang=js"

import "./HeaderProject.vue?vue&type=style&index=0&id=6f267e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f267e4a"]])

export default __exports__